import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from '../../ui/dialog';
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from '../../ui/table';
import { Badge } from '../../ui/badge';
import { Button } from '../../ui/button';
import { Trash2 } from 'lucide-react';

/**
 * Read-only RSVP table for a tournament game (iter277 extracted).
 * Each row shows player + response badge + responder + a remove button.
 */
const GameRsvpsDialog = ({
  open,
  onOpenChange,
  selectedGame,
  gameRsvps,
  rsvpIcons,
  rsvpColors,
  onRemovePlayer,
  submitting,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>RSVPs - vs {selectedGame?.opponent_team}</DialogTitle>
          <DialogDescription>
            {selectedGame?.game_date} at {selectedGame?.start_time} • {selectedGame?.age_category?.toUpperCase()}
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          {gameRsvps.length === 0 ? (
            <p className="text-center text-slate-500 py-4">No RSVPs yet</p>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Player</TableHead>
                  <TableHead>Response</TableHead>
                  <TableHead>Responded By</TableHead>
                  <TableHead className="w-16">Remove</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {gameRsvps.map(rsvp => (
                  <TableRow key={rsvp.id}>
                    <TableCell className="font-medium">{rsvp.player_name}</TableCell>
                    <TableCell>
                      <div className="flex items-center gap-2">
                        {rsvpIcons[rsvp.response]}
                        <Badge className={rsvpColors[rsvp.response]}>
                          {rsvp.response}
                        </Badge>
                      </div>
                    </TableCell>
                    <TableCell className="text-sm text-slate-500">
                      {rsvp.responded_by_name} ({rsvp.responded_by_role})
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => onRemovePlayer(rsvp.player_id, rsvp.player_name)}
                        disabled={submitting}
                        className="text-red-500 hover:text-red-700 hover:bg-red-50"
                        title="Remove player from game"
                        data-testid={`remove-player-${rsvp.player_id}`}
                      >
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default GameRsvpsDialog;
